import { ProvisionedConstants, STAGE } from './constants';

export enum FeatureFlag {
  RdpIntegration = 'rdpIntegration',
}

const DEFAULT_FLAGS: Record<FeatureFlag, boolean> = {
  [FeatureFlag.RdpIntegration]: false,
};

const STAGE_OVERRIDES: Partial<Record<STAGE, Partial<Record<FeatureFlag, boolean>>>> = {
  [STAGE.DEV]: { [FeatureFlag.RdpIntegration]: true },
  [STAGE.BETA]: { [FeatureFlag.RdpIntegration]: true },
  [STAGE.GAMMA]: { [FeatureFlag.RdpIntegration]: true },
};

export const isFeatureEnabled = (flag: FeatureFlag): boolean => {
  const stage = ProvisionedConstants.STAGE as STAGE;
  return { ...DEFAULT_FLAGS, ...STAGE_OVERRIDES[stage] }[flag] ?? false;
};
